import {
  iSettings,
  iWord,
  iWordHistory,
  iWords,
  iWordsHistory,
} from "@/lib/types";
import { words } from "@/lib/words";

export const categorizePercentage = (percentage: number) => {
  if (percentage < 50) return "weak";
  if (percentage < 70) return "medium";
  return "strong";
};

export const getHistoryCategorizedSummary = (wordHistory: iWordHistory) => {
  return Object.values(wordHistory).reduce(
    (acc: Record<string, number>, curr) => {
      acc[curr.category] = (acc[curr.category] || 0) + 1;
      return acc;
    },
    {},
  );
};

export const getRandomIndex = (wordPool?: iWords, excludedIndex?: string) => {
  if (!wordPool) {
    return -1;
  }

  const wordPoolIds = Object.keys(wordPool);

  if (excludedIndex) {
    const filteredWordPoolIds = wordPoolIds.filter(
      (id) => id !== excludedIndex,
    );

    return filteredWordPoolIds[
      Math.floor(Math.random() * filteredWordPoolIds.length)
    ];
  }

  return wordPoolIds[Math.floor(Math.random() * wordPoolIds.length)];
};

export const getRandomWordFromPool = (
  wordPool?: iWords,
  excludedIndex?: string,
) => {
  const randomIndex = getRandomIndex(wordPool, excludedIndex);
  return wordPool ? wordPool[randomIndex] : undefined;
};

export const getRandomIndexFromGlobalPool = (excludedIndexes?: string[]) => {
  const wordIds = Object.keys(words);

  if (excludedIndexes) {
    const filteredWordIds = wordIds.filter(
      (id) => !excludedIndexes.includes(id),
    );

    return filteredWordIds[Math.floor(Math.random() * filteredWordIds.length)];
  }

  return wordIds[Math.floor(Math.random() * wordIds.length)];
};

export const getRandomWordFromGlobalPool = (excludedIndex?: string[]) => {
  const randomIndex = getRandomIndexFromGlobalPool(excludedIndex);
  return words[randomIndex];
};

export const getChoices = (currQuestion?: iWord) => {
  if (!currQuestion) {
    return [];
  }

  const randomQuestionOne = getRandomWordFromGlobalPool([
    String(currQuestion.id),
  ]);

  const randomQuestionTwo = getRandomWordFromGlobalPool([
    String(currQuestion.id),
    String(randomQuestionOne.id),
  ]);

  const answers = [
    currQuestion.english,
    randomQuestionOne.english,
    randomQuestionTwo.english,
  ];

  return answers.sort(() => Math.random() - 0.5);
};

export const filterWords = (wordsObj: iWordsHistory, settings: iSettings) => {
  return Object.fromEntries(
    Object.entries(wordsObj).filter(([, word]) => {
      const { history } = word;

      if (!history) return settings.new; // New word
      return settings[history.category as "strong" | "medium" | "weak"]; // Match category
    }),
  );
};
